import {KeyValueStore} from './storageCommon';

/*
 * Api.
 */

export const keyValueStore: KeyValueStore = {
  read: readLocalStorage,
  set: setLocalStorage,
  clear: clearStorage,
};

/*
 * Helpers.
 */

function readLocalStorage(key: string) {
  try {
    const value = localStorage.getItem(key);
    if (!value) {
      return undefined;
    }

    return value;
  } catch (error) {
    return undefined;
  }
}

function setLocalStorage(key: string, value: string) {
  try {
    localStorage.setItem(key, value);
  } catch (error) {
    // Ignore.
  }
}

function clearStorage(): void {
  // TODO: Have better mechanism to detect if storage is ours.
  localStorage.clear();
}
